import React from 'react';

import MojitoCore from 'mojito/core';
import MojitoPresentation from 'mojito/presentation';

import {TextView} from '../text-view.jsx';

const {dispatch} = MojitoCore.Services.redux.store;
const PageSplitLayout = MojitoPresentation.Components.PageSplitLayout;
const GlobalLinks = MojitoPresentation.Components.GlobalLinks;
const UIViewImplementation = MojitoCore.Presentation.UIViewImplementation;
const {types: SystemSettingsTypes, selectors: SystemSettingsSelectors} = MojitoCore.Services.SystemSettings;
const IntentActions = MojitoCore.Intents.actions;
const IntentTypes = MojitoPresentation.Base.Intent.Types;
const {Button} = MojitoPresentation.Components;

export class StaticPageView extends UIViewImplementation {
    renderLink() {
        const {linkTitle, intent} = this.state.dynamicBottomLink;
        let onClick = null;

        if (intent) {
            onClick = () => {
                dispatch(IntentActions.publishIntent(intent.type, intent.data));
            };
        } else {
            onClick = () => {
                dispatch(
                    IntentActions.publishIntent(IntentTypes.SHOW_SIMPLE_TOAST, this.l10n.GENERIC.FEATURE_NOT_AVAILABLE)
                );
            };
        }

        return (
            <Button config={this.style.button} onClick={onClick}>
                {this.resolveString(linkTitle)}
            </Button>
        );
    }

    renderPageContent() {
        const {children} = this.props;

        return (
            <div style={this.style.container}>
                {children ? (
                    children
                ) : (
                    <TextView
                        header={this.resolveString(this.state.headerKey)}
                        text={this.state.pageContent}
                        config={this.style.textView}
                        downloadLink={this.state.downloadLink}
                    />
                )}
                {this.state.dynamicBottomLink ? this.renderLink() : null}
            </div>
        );
    }

    render() {
        let splitLayout = this.style.splitLayout || {};
        splitLayout.secondary = {show: !this.isMobile() && !this.state.hideGlobalLinks};
        return (
            <div className="DBXPersonalData" style={this.style.dbxpersonalData}>
                <PageSplitLayout config={splitLayout}>
                    {this.renderPageContent()}
                    <GlobalLinks />
                </PageSplitLayout>
            </div>
        );
    }

    isMobile() {
        let appMode = SystemSettingsSelectors.selectApplicationMode();
        return appMode === SystemSettingsTypes.APPLICATION_MODE.MOBILE;
    }
}

StaticPageView.getStyle = function (config, applicationMode, merge) {
    return {
        container: merge({backgroundColor: 'white', padding: '30px 10% 30px 10%'}, config.container),
        textView: merge({}, config.textView),
        button: merge({}, config.button || {}),
        image: {width: '60%'},
    };
};
